import { Box, HStack, Text } from "@chakra-ui/react"
import { ArrowUpRightIcon } from "@/components/icons"

const ArrowLink = ({ label = "View article" }) => {
  return (
    <>
      <HStack
        alignItems="stretch"
        aria-hidden="true"
        className="arrow"
        color={"black"}
        display={["none", "none", "flex"]}
        overflow="hidden"
        position={"absolute"}
        right={"14px"}
        rounded="full"
        top={"14px"}
        zIndex="10"
      >
        <HStack
          bg={"rgba(255,255,255,.8)"}
          border="1px solid #fcfcfc"
          borderColor={"gray.300"}
          className="label"
          marginRight="-30px"
          pl={3}
          pr={10}
          rounded="full"
          transform="translateX(100%)"
          transition="transform 0.16s ease-in"
          width="100%"
          zIndex={11}
        >
          <Text
            className="text"
            color="gray.700"
            fontFamily={"body"}
            fontSize={["xs", "sm", "sm"]}
            opacity={0}
            textWrap={"nowrap"}
            transition="opacity 0.4s ease"
          >
            {label}
          </Text>
        </HStack>
        <Box
          bg={"white"}
          border="1px solid #fcfcfc"
          borderColor={"gray.300"}
          css={{
            "& svg": {
              height: "12px",
              width: "12px",
            },
          }}
          padding={[1, 2, 2]}
          rounded="full"
          zIndex={12}
        >
          <ArrowUpRightIcon />
        </Box>
      </HStack>
    </>
  )
}

export default ArrowLink
